var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty-state"},[_c('div',[_c('img',{staticClass:"empty-image",attrs:{"src":require('../../../../assets/img/empty-box.png'),"alt":""}}),_vm._v(" "),_c('h3',{staticClass:"empty-title"},[_vm._v("Nothing to show")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b23506a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/kitchen/ArnergyReportComponents/EmptyViewComponent.vue
// module id = 2964
// module chunks = 1